import { gql } from '__generated__';

export default gql(`
  mutation EditRegistration($input: EditRegistrationInput!) {
    editRegistration(input: $input) {
      id
    }
  }
`);
